import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmAuthNeedEnterCaptchaError } from '@/core/error/transport/auth/TmAuthNeedEnterCaptchaError'
import { EndpointsEnum } from '@/services/endpoints'

export const emailVerificationResendNeedCaptchaErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.registrationEmailResend,
  klass: TmAuthNeedEnterCaptchaError,
}
